module.exports = __webpack_public_path__ + "banner-admin.558d40b41e8af38ba661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/banner-admin.png
// module id = 487
// module chunks = 5